// Este archivo contiene las rutas de los componentes de la carpeta admin
export default {
  component: () => import("@/modules/admin/layouts/AdminLayout"),
  children: [
    {
      path: "/admin/panel",
      name: "admin-panel",
      component: () => import("@/modules/admin/views/AdminPanelView.vue"),
    },
    {
      path: "/admin/alumnos",
      name: "alumnos",
      component: () => import("@/modules/admin/views/RegistroAlumnosView.vue"),
    },
    {
      path: "/admin/semestres",
      name: "semestres",
      component: () => import("@/modules/admin/views/RegistroSemestreView.vue"),
    },
    {
      path: "/admin/registro-admin",
      name: "registro-admin",
      component: () => import("@/modules/admin/views/RegistroAdminView.vue"),
    },
    {
      path: "/admin/profesores",
      name: "profesores",
      component: () => import("@/modules/admin/views/RegistroDocentesView.vue"),
    },
    {
      path: "/admin/grupos",
      name: "grupos",
      component: () => import("@/modules/admin/views/RegistroGruposView.vue"),
    },
    {
      path: "/admin/inscripcion-grupos",
      name: "inscripcion-grupos",
      component: () => import("@/modules/admin/views/InscripcionGruposView.vue"),
    },
    {
      path: "/admin/examen-titulacion",
      name: "examen-titulacion",
      component: () =>
        import("@/modules/admin/views/RegistroExamenTitulacionView.vue"),
    },
    {
      path: "/admin/nivel",
      name: "nivel",
      component: () => import("@/modules/admin/views/InsertarNivelView.vue"),
    },
    {
      path: "/admin/registro-examen-titulacion",
      name: "registro-examen-titulacion",
      component: () =>
        import("@/modules/admin/views/AdministrarExamenTitulacionView.vue"),
    },
    {
      path: "/admin/constancias-posgrado",
      name: "constancias-posgrado",
      component: () =>
        import("@/modules/admin/views/ConstanciasPosgradoView.vue"),
    },
    {
      path: "/admin/periodos",
      name: "periodos",
      component: () => import("@/modules/admin/views/PeriodoRegistroView.vue"),
    },
    {
      path: "/admin/encuesta-categorias",
      name: "encuesta-categorias",
      component: () =>
        import("@/modules/admin/views/RegistroEncuestaCategoriasView.vue"),
    },
    {
      path: "/admin/encuesta-preguntas",
      name: "encuesta-preguntas",
      component: () =>
        import("@/modules/admin/views/RegistrarEncuestaPreguntasView.vue"),
    },
    {
      path: "/admin/visualizar-encuesta",
      name: "visualizar-encuesta",
      component: () =>
        import("@/modules/admin/views/VisualizarEncuestaView.vue"),
    },
    {
      path: "/admin/encuesta-reportes",
      name: "encuesta-reportes",
      component: () =>
        import("@/modules/admin/views/EncuestaReportesView.vue"),
    },
    {
      path: "/admin/recursos-visuales",
      name: "recursos-visuales",
      component: () =>
        import("@/modules/admin/views/RecursosVisualesView.vue"),
    },
    {
      path: "/admin/password",
      name: "password",
      component: () => 
        import("@/modules/admin/views/CambiarPasswordView.vue"),
    },
    {
      path: "/admin/constancia-licenciatura",
      name: "constancia-licenciatura",
      component: () => import("@/modules/admin/views/ConstanciaLicenciatura.vue"),
    },
    {
      path: "/admin/cargar-manual",
      name: "cargar-manual",
      component: () => import("@/modules/admin/views/CargarManualesView.vue"),
    }
  ],
};
